import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {BehaviorSubject, of} from 'rxjs';
import {DataService} from '../../services/data.service';
import {FrtBillOfLadingDetails, BolCorrectionNoticeEntity} from 'src/app/shared/common-components/common-structure';
import {switchMap, catchError} from 'rxjs/operators';
import {LoadingService} from '../../services/loading/loading.service';

@Injectable({
  providedIn: 'root'
})

export class FrtBillOfLadingService extends DataService {

  constructor(http: HttpClient, private loader: LoadingService) {
    super(http);
  }

  private baseURI = '/tmssserver/api/frtboldetails/';
  shipmentId = new BehaviorSubject<number>(0);
  frtBolDetailsId = new BehaviorSubject<number>(0);

  frtBolFinalizationDetails$ = this.frtBolDetailsId.pipe(switchMap(frtBolDetailsId =>
    this.http.get<BolCorrectionNoticeEntity>(this.baseURI + frtBolDetailsId + '/getbolcorrectionnotice')
      .pipe(catchError(e => {
        return of({} as BolCorrectionNoticeEntity);
      }))
  ));

  updateFrtBolDetailsId(frtBolDetailsId: number) {
    this.frtBolDetailsId.next(frtBolDetailsId);
  }

  /**
   * @description retrieves frt bol details
   * @param shipmentid: shipment info id of the shipment
   */
  getBolDetailsByShipmentId(shipmentid: number): Observable<any> {
    return this.http.get(this.baseURI + shipmentid + '/getBolDetails/');
  }

  getBolDetailsByBolDetailsId(bolDetailsId: number): Observable<any> {
    return this.http.get(this.baseURI + bolDetailsId + '/getBolDetailsByBolId/');
  }

  /**
   * @description saves the online hhg shipment
   */
  saveBolCorrectionNoticeDetails(frtCorrectionNotice: any) {
    return this.http.post(this.baseURI + 'updatebolcorrectnotice', frtCorrectionNotice);
  }

  saveBolInfo(frtBillOfLadingDetails: FrtBillOfLadingDetails): Observable<any> {
    return this.http
      .put(this.baseURI + 'updateBolDetails', frtBillOfLadingDetails);
  }
}

